import { render, staticRenderFns } from "./MultiEmbedPage.vue?vue&type=template&id=2ee56206&scoped=true&"
import script from "./MultiEmbedPage.vue?vue&type=script&lang=js&"
export * from "./MultiEmbedPage.vue?vue&type=script&lang=js&"
import style0 from "./MultiEmbedPage.vue?vue&type=style&index=0&id=2ee56206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee56206",
  null
  
)

export default component.exports